export default {"src":"/_next/static/media/fOusg.4f87dc4f.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};